<template>
    <div class="row mb-2 mb-md-4 sticky-lg-top">
        <div class="col-12">
            <div class="card border-0">
                <div class="card-header rounded-16 mb-3 px-2 py-3 fixedToBot bg-grey" :class="{'d-none': !fixedToBot}">
                    <div class="d-flex align-items-center justify-content-between">
                        <span class="fw-bold fs-5">Order total</span>
                        <b class="fs-4">£{{ updatedBasket.sub_total ?? '0.00' }}</b>
                        <span @click="scrollToBottom()" class="d-block d-sm-none ms-4 btn btn-primary">{{ buttonText
                            }}</span>
                    </div>
                </div>
                <div class="card-header rounded-16 mb-3 px-2 py-3 bg-grey d-block d-sm-none">
                    <div class="d-flex align-items-center justify-content-between">
                        <span class="fw-bold fs-5">Order total</span>
                        <b class="fs-5">£{{ updatedBasket.sub_total ?? '0.00' }}</b>
                    </div>
                </div>
                <div class="card-body p-0 rounded-16 mb-3">
                    <div class="bg-grey py-3 d-flex align-items-center gap-2 rounded-top">
                        <i class="fa-kit fa-trolley text-16"></i>
                        <b class="text-16">Your total</b>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mb-1 py-2 px-3">
                        <template v-if="tyresInBasket?.length > 0 && sizeUrl">
                            <div class="d-block small">Selected tyres</div>
                            <div class="text-end" v-if="tyresInBasket?.length == 1">
                                <a :href="decodeURI(tyreUrlFromBasket)" class="small text-primary" title="Change Tyres">(Change tyres)</a>
                            </div>
                        </template>
                        <template v-else>
                            <p class="mb-0">No tyres selected, please add tyres to proceed.</p>
                        </template>
                    </div>
                    <div v-for="(product, index) in updatedBasket?.products" :key="product.st_code" class="px-3">
                        <div v-if="product.product_type != 'service'">
                            <div class="d-flex justify-content-between align-items-center">
                                <b>{{ product.brand }}</b>
                                <p class="mb-0">£{{ product.display_total }}</p>
                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex flex-column">
                                    <p class="mb-0">{{ product.tyre_range }}</p>
                                    <small class="fw-light">{{ product.size }} {{ product.load_speed }}</small>
                                </div>
                                <div class="d-flex align-items-center">
                                    <select name="quantity" id="quantity" class="d-inline-block form-select float-end"
                                        @change="this.updateQuantity($event, product.st_code, true)">
                                        <option v-for="index in 5" :key="index" :value="index" :selected="index == product.quantity">{{ index }}</option>
                                    </select>
                                    <div @click="removeProduct(product.st_code)">
                                        <i class="fa-regular fa-trash-can cursor-pointer ms-3" title="Remove Tyre"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="px-3" v-if="servicesInBasket?.length > 0">
                        <hr class="mb-0">
                    </div>
                    <template v-if="servicesInBasket?.length > 0">
                        <div v-for="(product, index) in servicesInBasket" :key="product.st_code" class="py-2 px-3">
                            <p v-if="index === 0" class="small my-2">Selected extras</p>
                            <div class="d-flex justify-content-between" v-if="product.product_type == 'service'">
                                <b>{{product.service_name}} {{ product.description }}</b>
                                <span>£{{ product.display_total }}</span>
                            </div>
                        </div>
                    </template>
                    <div class="px-3">
                        <hr class="mt-2 mb-0">
                    </div>
                    <div v-if="updatedBasket.mobile_fitting > 0"
                        class="px-3 d-flex align-items-center py-3 justify-content-between">
                        <b>Mobile Fitting amount:</b>
                        <b>£{{ updatedBasket.mobile_fitting }}</b>
                    </div>
                    <div class="px-3" v-if="updatedBasket.mobile_fitting > 0">
                        <hr class="mt-0 mb-0">
                    </div>
                    <div v-if="updatedBasket.delivery_amount > 0"
                        class="px-3 d-flex align-items-center py-3 justify-content-between">
                        <b>Delivery amount:</b>
                        <b>£{{ updatedBasket.delivery_amount }}</b>
                    </div>
                    <div class="px-3" v-if="updatedBasket.delivery_amount > 0">
                        <hr class="mt-0 mb-0">
                    </div>
                    <div class="p-3" v-if="updatedBasket.disposal_fee > 0">
                        <div class="d-flex align-items-center justify-content-between">
                            <b>Environmental Fee:</b>
                            <span>&pound;{{ basket.disposal_fee }}</span>
                        </div>
                        <disposal-fee-info></disposal-fee-info>
                    </div>
                    <div class="px-3" v-if="updatedBasket.disposal_fee > 0">
                        <hr class="mt-0 mb-0">
                    </div>
                    <div class="px-3 d-flex align-items-center py-3 justify-content-between">
                        <b>Total</b>
                        <b>£{{ updatedBasket.sub_total ?? '0.00' }}</b>
                    </div>
                </div>
                <div class="card-body p-0 rounded-16 mb-3" v-if="updatedBasket.home_delivery == 0">
                    <div class="bg-grey py-3 px-3 d-flex align-items-center gap-2 rounded-top">
                        <i class="fa-kit fa-click-and-collect text-16"></i>
                        <b class="text-16">Your fitting</b>
                    </div>
                    <div class="px-3 py-3 d-flex flex-column gap-2" v-if="updatedBasket.home_delivery == 0">
                        <div class="d-flex gap-2" v-if="updatedBasket?.fitter_id">
                            <i class="fa-kit fa-address mt-1" title="Fitter details"></i>
                            <div>
                                <div v-if="updatedBasket?.fitter?.name || updatedBasket?.fitter?.address">
                                    <p class="mb-0">{{ updatedBasket?.fitter?.name }}, {{ updatedBasket?.fitter?.address }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex gap-2" v-if="updatedBasket?.fitter_id">
                            <i class="fa-kit fa-change-slot mt-1" title="Fitting appointment"></i>
                            <div>
                                <div v-if="updatedBasket?.app_date">
                                    <p class="mb-0">{{ formattedDate }}</p>
                                    <p class="mb-0" v-if="updatedBasket?.app_time">{{ updatedBasket?.app_time }}</p>
                                </div>
                            </div>
                        </div>
                        <a href="/choose-fitter" class="btn btn-custom-white" title="Change Fitter">Change fitter</a>
                        <div v-if="!updatedBasket?.fitter_id">
                            <p class="mb-0">No fitter selected</p>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0 rounded-16" :class="{'mb-3': buttonUrl?.includes('booking-details')}"
                    v-if="buttonUrl?.includes('booking-details')">
                    <div class="bg-grey py-3 px-3 d-flex align-items-center gap-2 rounded-top">
                        <b class="text-16">Consent</b>
                    </div>
                    <new-marketing :basket="updatedBasket"></new-marketing>
                </div>
                <div ref="mobileAnchor" class="mobileAnchor"></div>
                <a :href="buttonUrl" class="d-none d-lg-block btn btn-primary">{{ buttonText }}</a>
            </div>
        </div>
    </div>
    <teleport to="body">
        <info-modal></info-modal>
    </teleport>
</template>
<script>
    import dayjs from '@frontend/node_modules/dayjs';
    import basketFunctions from "@shared/mixins/basket";
    export default {
        mixins: [
            basketFunctions
        ],
        props: [
            'fitter', 
            'basket',
            'buttonUrl',
            'buttonText',
            'priceBgColour',
            'linkColour'
        ],
        inject: ['sizeUrl'],
        data() {
            return {
                updatedBasket: this.basket,
                fixedToBot: true
            }
        },
        created () {
            window.addEventListener('scroll', this.handleScroll);
        },
        unmounted () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        mounted() {
            this.emitter.on('updateBasket', data => {
                this.updatedBasket = data;
            });
        },
        methods: {
            async removeProduct(st_code) {
                await this.deleteFromBasket(st_code);
            },
            elementIsVisibleInViewport(el, partiallyVisible = false) {
                var element = document.getElementsByClassName(el);

                const { top, left, bottom, right } = element[0].getBoundingClientRect();
                const { innerHeight, innerWidth } = window;
                return partiallyVisible
                    ? ((top > 0 && top < innerHeight) ||
                        (bottom > 0 && bottom < innerHeight)) &&
                        ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
                    : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
            },
            handleScroll() {
                this.$nextTick(() => {
                    this.fixedToBot = !this.elementIsVisibleInViewport('mobileAnchor');
                });
            },
            scrollToBottom() {
                this.$refs.mobileAnchor.scrollIntoView({ behavior: "smooth" })
            }
        },
        computed: {
            servicesInBasket() {
                let filtered = this.updatedBasket?.products?.filter(product => product.product_type == 'service');
                return filtered;
            },
            tyreUrlFromBasket() {
                return this.updatedBasket?.products[0].width + '-' + this.updatedBasket?.products[0].profile + '-' + this.updatedBasket?.products[0].rim;
            },
            tyresInBasket() {
                let filtered = this.updatedBasket?.products?.filter(product => product.product_type == 'product');
                return filtered;
            },
            formattedDate() {
                if(this.updatedBasket?.app_date) {
                    var advancedFormat = require('@frontend/node_modules/dayjs/plugin/advancedFormat');
                    dayjs.extend(advancedFormat);

                    return dayjs(this.updatedBasket.app_date).format('dddd Do MMMM YYYY');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .card-header {
        border: 1px solid #808080;
        .small {
            margin-bottom: -5px;
        }
    }
    .card-body {
        border: 1px solid #808080;
        & > div:first-child {
            border-bottom: 1px solid #808080;
        }
        @media screen and (min-width: 992px) and (max-width: 1199px) {
            #quantity {
                padding-right: 29px;
            }
        }
    }
    .sticky-lg-top {
        top: 10px;
        z-index: 5;
    }
    .fixedToBot {
        @media screen and (max-width: 576px) {
            position: fixed;
            bottom: 0;
            width: 100%;
            left: 0;
            z-index: 2;
            border-radius: 0 !important;
            margin-bottom: 0 !important;
        }
    }
</style>